import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserPortfolioCategoryEditModalComponent } from './user-portfolio-category-edit-modal.component';

@NgModule({
  imports: [CommonModule, PipesModule, TrackingModule, UiModule],
  declarations: [UserPortfolioCategoryEditModalComponent],
})
export class UserPortfolioCategoryEditModalModule {}
